import React, { Component } from "react";
import InlinePriceChart from "./InlinePriceChart";
import axios from "axios";
import { connect } from "react-redux";
import accounting from "accounting";
import { Col } from "Components";
class Comp extends Component {
  constructor(props) {
    super(props);
    this.state = {
      filter: "Bireysel",
      from: "USD",
      to: "TRY",
      result: 0,
      amount: 1
    };
  }
  componentDidMount = () => {
    this.getCurrencyState();
  };
  getCurrencyState = async () => {
    if (this.state.from && this.state.to) {
      const res = await axios.get(
        `http://free.currencyconverterapi.com/api/v5/convert?q=${
          this.state.from
        }_${this.state.to}&compact=y&apiKey=5c0afcbefef82f2b4e80`
      );
      let rate = res.data[`${this.state.from}_${this.state.to}`].val;
      this.setState({
        rate,
        result:
          parseInt(
            this.state.amount
              .toString()
              .split(",")
              .join("")
          ) * rate
      });
    }
  };
  render = () => (
    <div className="minus-19-top">
      <div className="container row statistics bg-cream">
        <Col className="item" l={2} m={6} s={12}>
          <div className="wrapper">
            <p className="title">ALTIN</p>
            <div className="chart">
              <InlinePriceChart />
            </div>
            <p className="amount">140.765,90</p>
          </div>
        </Col>
        <Col className="item" l={2} m={6} s={12}>
          <div className="wrapper">
            <p className="title">ALTIN</p>
            <div className="chart">
              <InlinePriceChart />
            </div>
            <p className="amount">140.765,90</p>
          </div>
        </Col>
        <Col className="item" l={2} m={6} s={12}>
          <div className="wrapper">
            <p className="title">ALTIN</p>
            <div className="chart">
              <InlinePriceChart />
            </div>
            <p className="amount">140.765,90</p>
          </div>
        </Col>
        <Col className="item" l={2} m={6} s={12}>
          <div className="wrapper">
            <p className="title">ALTIN</p>
            <div className="chart">
              <InlinePriceChart />
            </div>
            <p className="amount">140.765,90</p>
          </div>
        </Col>
        <Col className="item" l={2} m={6} s={12}>
          <div className="wrapper">
            <p className="title">ALTIN</p>
            <div className="chart">
              <InlinePriceChart />
            </div>
            <p className="amount">140.765,90</p>
          </div>
        </Col>
        <Col className="item" l={2} m={6} s={12}>
          <div className="wrapper">
            <p className="title">ALTIN</p>
            <div className="chart">
              <InlinePriceChart />
            </div>
            <p className="amount">140.765,90</p>
          </div>
        </Col>
      </div>
      <div className="bg-gray statistics_params">
        <div className="container">
          <div>
            <p className="starter">KUR HESAPLA</p>
          </div>
          <div className="border-right">
            <p className="input_label">MIKTAR</p>
            <input
              value={this.state.amount}
              onChange={e =>
                this.setState({
                  amount: accounting.formatNumber(e.target.value),
                  result:
                    parseInt(e.target.value.split(",").join("")) *
                    this.state.rate
                })
              }
              type="text"
            />
          </div>
          <div>
            <p className="input_label">Para Birimi</p>
            <select
              value={this.state.from}
              onChange={e => {
                this.setState({
                  from: e.target.value
                });
                setTimeout(() => {
                  this.getCurrencyState();
                }, 100);
              }}
            >
              <option>USD</option>
              <option>TRY</option>
              <option>EUR</option>
              <option>GBP</option>
            </select>
          </div>
          <div className="border-right">
            <p className="input_label">Çevirleceği Birim</p>
            <select
              value={this.state.to}
              onChange={e => {
                this.setState({
                  to: e.target.value
                });
                setTimeout(() => {
                  this.getCurrencyState();
                }, 100);
              }}
            >
              <option>TRY</option>
              <option>USD</option>
              <option>EUR</option>
              <option>GBP</option>
            </select>
          </div>
          <div>
            <p className="result">
              {accounting.formatNumber(this.state.result, 3)} {this.state.to}
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}
const mapStateToProps = state => ({
  navigation: state.navigation,
  screen: state.screen
});
export default connect(mapStateToProps)(Comp);
